import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const isBgDark = (color: string) => {
  return ['purple', 'midnight-blue'].includes(color)
}

export type BackgroundConfig = {
  classes: string
  facet: string
}

export const getBackgroundConfig = (
  bgColor?: string,
  textColorValue?: string
): BackgroundConfig => {
  const colorClasses = []
  let facet = ''
  const hasFacet = bgColor?.includes('facet')

  switch (bgColor) {
    case BackgroundColor.STONE:
      colorClasses.push('u-bgColorStone')
      break
    case BackgroundColor.PURPLE_LIGHT:
    case BackgroundColor.PURPLE_TINT:
      colorClasses.push('u-bgColorPurpleLight10')
      break
    case BackgroundColor.LIME_LIGHT:
    case BackgroundColor.LIME_TINT:
      colorClasses.push('u-bgColorLimeLight20')
      break
    case BackgroundColor.MINT_LIGHT:
    case BackgroundColor.MINT_TINT:
      colorClasses.push('u-bgColorMintLight10')
      break
    case BackgroundColor.BERRY_TINT:
      colorClasses.push('u-bgColorBerryLight10')
      break
    case BackgroundColor.ORANGE_TINT:
      colorClasses.push('u-bgColorOrangeLight20')
      break
    case BackgroundColor.PURPLE:
      colorClasses.push('u-bgColorPurple')
      break
    case BackgroundColor.MIDNIGHT_BLUE:
      colorClasses.push('u-bgColorMidnightBlue')
      break
    case BackgroundColor.TRANSPARENT:
      colorClasses.push('u-bgColorTransparent')
      break
    case BackgroundColor.FADED_WHITE_FACET:
      facet = hasFacet
        ? `url(${window.AMPCOMPATH}images/facets/banner/white.svg)`
        : ''
      break
    default:
      colorClasses.push('u-bgColorWhite')
  }

  const isDark = bgColor ? isBgDark(bgColor) : false
  const contrastClass =
    textColorValue === 'white' || isDark
      ? 'Content Content--reversed'
      : 'Content'

  return {
    classes: `${colorClasses.join(' ')} ${contrastClass}`,
    facet
  }
}
